import { table101 } from "../data/table101";
import { table102 } from "../data/table102";
import { table104 } from "../data/table104";
import { table105 } from "../data/table105";
import { table106 } from "../data/table106";
import { table108 } from "../data/table108";
import { table110 } from "../data/table110";
import { table111 } from "../data/table111";
import { table113 } from "../data/table113";
import { table114 } from "../data/table114";
import { table201 } from "../data/table201";
import { table202 } from "../data/table202";
import { tabledeclaration } from "../data/tabledeclaration";
import { tabledepreciation } from "../data/tabledepreciation";
import { tableinfo } from "../data/tableinfo";
import { tablesettings } from "../data/tablesettings";
import { TableColumn } from "../interface";

const columnLookup: { [key: string]: TableColumn[] } = {
    table101,
    table102,
    table104,
    table105,
    table106,
    table108,
    table110,
    table111,
    table113,
    table114,
    table201,
    table202,
    tabledepreciation,
    tablesettings,
    tableinfo,
    tabledeclaration
};

export { columnLookup };
